<template lang="pug">
  section.flex-body(v-if="rows && rows.length")
    component(v-for="(row, i) in rows", v-if="show(row, i)", :is="'row-' + row.acf_fc_layout", :row="row", :index="i", :key="i")
</template>

<script>
import BlauTitle from './BlauTitle'
import Header from './Flx__Header'
import RichText from './RichText'
import Quote from './Quote'
import Carousel from './Flx__Carousel'
import VideoPlayer from './VideoPlayer'
import AudioPlayer from './AudioPlayer'
import HeroVideo from './Flx__HeroVideo'
export default {
  name: 'FlexBody',
  props: ['rows'],
  components: {
    'row-header': Header,
    'row-blau_title': BlauTitle,
    'row-text': RichText,
    'row-text_article': RichText,
    'row-quote': Quote,
    'row-carousel': Carousel,
    'row-video': VideoPlayer,
    'row-audio_player': AudioPlayer,
    'row-hero_video': HeroVideo
  },
  methods: {
    show (row, index) {
      const limit = this.limit && index >= this.limit
      return !limit && this.$options.components['row-' + row.acf_fc_layout]
    }
  }
}
</script>

<style>
</style>
